// Copyright (c) 2019 Deere & Company

import './index.scss';
import * as busyCounter from '../../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import {
    convertToArray, convertToArrayProdSeries, defaultClaimSrcProperties, getUserEditedInputs,
} from '../../common';
import { createErrorMessage, createSuccessMessage } from '../../../shared/action-creator/alert-messages';
import {
    filterEmpty, isAlphanumeric, isModelCdValid, isPartNumberValid, isSupplierIdValid,
} from '../../../shared/services/validator';
// import { getFieldValue } from '../../../shared/services/commonFunctions';
import { getAdminReportDownload, getComponentFactoryCode } from '../../../admin/repositories';
import {
    getDefaultFactoryCode, getDesignModule, getFactories, getFactoryClaim, getMfgModule,
} from '../../../app/common/repositories';
import {
    getFindClaimDownloadReports,
    getSearchedClaimData,
} from '../../repositories';

import Accordion from '../../../app/common/components/accordion';
import BusyCounterLoadingIndicator from '../../../shared/components/busyCounter/busy-counter-loading-indicator';
import Checkbox from '../../../shared/components/checkbox';
import ClaimDetailsPanel from '../../../claim-details';
import ClaimSearchAside from './aside';
import InputWithFaIcon from '../../../shared/components/labeled-input-with-fa-icon';
import LabeledDateRangePicker from '../../../shared/components/labeled-date-picker/LabeledDateRangePicker';
import LabeledInput from '../../../shared/components/labeled-input';
import LabeledMonthRangePicker from '../../../shared/components/labeled-month-range-picker';
import LabeledNumberRangePicker from '../../../shared/components/labeled-number-range-picker';
import LabeledTextarea from '../../../shared/components/labeled-textarea';
import MultiSelect from 'react-select';
import OptionsDropDown from '../../../shared/components/options-drop-down';
import ProductSearch from '../product-search';
import PropTypes from 'prop-types';
import RegionSearch from '../region-search';
import SearchResultPanel from '../search-result-panel';
import SimpleMultipleEntryPopup from '../../../shared/components/simple-multiplentry-popup';
import { cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import { customizeErrorAlert } from '../../../shared/services/customize-error-alert-bar';
import { showLoadingIndicator } from '../../../shared/state/busy-counter';
import { stringToArray } from '../../../shared/services/common-functions';
import AgcmdlDetails from '../../../claim-details/components/agcmdldetails';


class FindClaim extends Component {

    state = {
        factories: [],
        isSearch: false,
        isClaimDetails: false,
        selectedWarrantyClaimID: 0,
        gridAPI: {},
        claimDetailsInfo: {
            totalClaims: 0,
            displayedClaimIndex: 0,
        },
        modifiedSearch: [],
        showDropDownMenu: false,
        // productList: [],
        defaultProperties: {},
        isPopupOpen: false,
        isValidEntry: true,
        popupName: '',
        popupPropertyName: '',
        popupPropertyValue: '',
        productSeriesList: [],
        FactoryClaimList: [],
        selectedFactoryClaim: null,
        DesignModuleList: [],
        selectedDesignModule: null,
        MfgModuleList: [],
        selectedMfgModule: null,
        selectedClaimNumber: 0,
        disabled: false,
        searchInputs: cloneDeep( defaultClaimSrcProperties ),
        componentDropdownList: [],
        claimCount: {

            basicSrcInps: 0,

            ProdSrcInps: 0,

            FuncSrcInps: 0,

            RegionCodeSrcInps: 0,

            OtherSrcInps: 0,
        },
        selectedBranchCurrency:null,
    }


    selectedSearchInputs = {
        basicSrcInps: [
            'factoryCode',
            'claimNumbers',
            'pins',
            'pipNumbers',
            'partNumber',
            'processDate',
            'buildDate',
            'buildMonth',
            'serialNumber',
            'partDescription',
            'modelCdList',
            'creditMemoNumber',
            'workOrderNumber',
            'dealerAccount'
        ],
        ProdSrcInps: [
            'productSeriesIds',
            'productSubSeriesIds',
            'baseCodeIds',
        ],
        FuncSrcInps: [
            'functionCodeName',
            'designTeamCode',
            'manufacturingModule',
            'manufacturingFactoryCode',
            'componentFunctionCodeName',
            'componentFactoryCode',
            'factoryClaimTypeIds',
        ],
        RegionCodeSrcInps: [
            'regionCode',
            'branchIds',
        ],
        OtherSrcInps: [
            'dealerAccount',
            'componentPin',
            'supplierId',
        ],
    };

    getSearchedLabels = {
        factoryCode: 'Factory Code',
        claimNumbers: 'Claim Number',
        pins: 'PIN Number',
        modelCdList: 'Model Number',
        pipNumbers: 'PIP Number',
        partNumber: 'Part Number',
        includeReplacementParts: 'Include Replacement Parts',
        processDate: 'Process Date',
        buildDate: 'Build Date',
        buildMonth: 'Build Month',
        serialNumber: 'Serial Number',
        productSeriesIds: 'Product Series',
        productSubSeriesIds: 'Product Sub Series',
        baseCodeIds: 'Product BaseCode',
        regionCode: 'Region',
        branchIds: 'Branch',
        factoryClaimTypeIds: 'Factory Claim Type',
        manufacturingModule: 'Manufacturing Module',
        componentFactoryCode: 'Component FactoryCode',
        designTeamCode: 'Design TeamCode',
        functionCodeName: 'Function CodeName',
        componentFunctionCodeName: 'Component FunctionCode Name',
        supplierId: 'Supplier Id',
        componentPin: 'Component Pin',
        dealerAccount: 'Dealer Account',
        noSupplierAssigned: 'No Supplier Assigned',
        partDescription: 'Part Description',
        branchType:'Currency',
        creditMemoNumber:'Credit Memo Number',
        workOrderNumber:'Work Order Number'
    }

    componentWillMount = () => {

        this.onToggleDiv = this.onToggleDiv.bind( this );
        this.handleOutsideClick = this.handleOutsideClick.bind( this );

        this.loadDefaults();

    }

    componentWillReceiveProps ( nextProps ) {

        if ( nextProps.reload === 'findClaim' ) {

            this.onBackToResult();
            this.onNewSearch();
            nextProps.updateReload();

        }

    }


    componentDidUpdate = ( prevProps, prevState ) => {

        if ( prevProps.factoryCode !== this.props.factoryCode ) {

            const obj = { ...this.state.searchInputs };
            obj.factoryCode = this.props.factoryCode;
            this.setState( {
                searchInputs: obj,
            } );

        }

        if ( prevState.searchInputs.partNumber !== this.state.searchInputs.partNumber && this.state.searchInputs.partNumber === '' ) {

            const obj = { ...this.state.searchInputs };
            obj.includeReplacementParts = false;
            this.setState( {
                searchInputs: obj,
            } );

        }

    }

    getComponentEditedInpsCount = ( modifiedInput = this.state.modifiedSearch ) => {

        const claimCounts = cloneDeep( this.state.claimCount );

        Object.keys( this.selectedSearchInputs ).forEach( property => {

            claimCounts[property] = 0;
            modifiedInput.forEach( item => {

                if ( this.selectedSearchInputs[property].includes( item[0] ) ) {

                    claimCounts[property] += 1;

                }

            } );

        } );

        this.setState( {
            claimCount: claimCounts,
        } );

    }


    updatedSrcInputs = modifiedInput => {

        this.setState( { modifiedSearch: modifiedInput } );
        this.getComponentEditedInpsCount( modifiedInput );

    };

    loadDefaults = () => {

        this.props.increaseCounter();
        getFactories().then( response => {

            const recFactories = [];
            response.forEach( factory => {

                recFactories.push( {
                    factoryCode: factory.factoryCode,
                    factoryDescription: `${factory.factoryCode} - ${factory.factoryDescription}`,
                } );

            } );

            let defaultFactory = getDefaultFactoryCode();

            this.setState( {
                factories: recFactories,
            } );

            if ( defaultFactory === '' && recFactories.length > 0 ) defaultFactory = recFactories[0].factoryCode;
            this.handleFactoryCodeChange( defaultFactory );
            this.handleFactoryClaimTypeChange();
            this.updateDesignModule( defaultFactory );
            this.updateMfgModule( defaultFactory );
            this.updatedSrcInputs( getUserEditedInputs( this.state.searchInputs ) );
            this.getComponentEditedInpsCount( getUserEditedInputs( this.state.searchInputs ) );


            this.props.decreaseCounter();

        } );
        this.ComponentFactoryDropdownList();

    }

    onToggleDiv = () => {
        // console.log("onToggleDiv :: ");

        if ( !this.state.showDropDownMenu ) {

            document.addEventListener( 'click', this.handleOutsideClick, false );

        } else {

            document.removeEventListener( 'click', this.handleOutsideClick, false );

        }


        const status = !this.state.showDropDownMenu;
        this.setState( {
            showDropDownMenu: status,
        } );

    }


    updateFactoryCode = obj => {

        const selectedOption = {
            target: {
                name: 'factoryCode',
                value: obj,
            },
        };
        this.updateSearchInput( selectedOption );
        this.handleFactoryCodeChange( selectedOption.target.value );
        this.updateDesignModule( selectedOption.target.value );
        this.updateMfgModule( selectedOption.target.value );

    }


    accordionSecondaryText = () => (
        <span className="accordion-secondary-text caution">
            <span className="is-required red-font">*</span>
            Atleast One Criteria Must be Specifed
        </span>
    );

    onClosePopup = () => {

        this.setState( {
            isPopupOpen: false,

        } );

    }


    noOfEntries = entries => filterEmpty( entries ).length;

    initiatePopup = ( propertyName, obj ) => {

        if ( this.state.searchInputs.factoryCode === '' && propertyName === 'modelCdList' ) {

            this.setState( {
                isPopupOpen: false,
                popupName: obj.currentTarget.className,
                popupPropertyName: propertyName,
                popupPropertyValue: this.state.searchInputs[propertyName],

            } );

        } else {

            this.setState( {
                isPopupOpen: true,
                popupName: obj.currentTarget.className,
                popupPropertyName: propertyName,
                popupPropertyValue: this.state.searchInputs[propertyName],

            } );

        }

    }

    initiateSupplierPopup = ( propertyName, obj ) => {

        if ( this.state.disabled === false ) {

            this.setState( {
                isPopupOpen: true,
                popupName: obj.currentTarget.className,
                popupPropertyName: propertyName,
                popupPropertyValue: this.state.searchInputs[propertyName],
            } );

        }

    }

    valuesHavingSeparators = propertyVal => {

        const match = ( propertyVal ).search( ',' ) > 0 ? true : /\r|\n/.exec( propertyVal ) !== null;

        return match && this.noOfEntries( propertyVal ) > 1;

    }


    validateRange = range => {

        if ( ( range.from === 0 || range.from === null || range.from === '' ) ||
            ( range.to === 0 || range.to === null || range.to === '' ) ) return false;
        return true;

    }


    onSubmit = clickedEvent => {
       
    // console.log("on submit ", this.state.searchInputs.option);
        const download = clickedEvent.currentTarget.className;

        this.setState( {
            ...this.state,
            isValidEntry: true,
        } );


        let isValidEntry = true;
        const payLoad = cloneDeep( this.state.searchInputs );
        const mandatoryCheck = [
            'buildDate',
            'processDate',
            'buildMonth',
        ];

        const manipulatePayloadProperty = [
            'pins',
            'pipNumbers',
            'partNumber',
            'claimNumbers',
            'supplierId',
            'modelCdList',
            'creditMemoNumber',
            'workOrderNumber',
            'dealerAccount'
        ];
        const mandatoryValidateProperty = [
            'pins',
            'pipNumbers',
            'serialNumber',
            'claimNumbers',
            'buildDate',
            'processDate',
            'buildMonth',
            'partNumber',
            'creditMemoNumber',
            'workOrderNumber',
            'dealerAccount'
        ];
        const propertyToBeConvertToArray = [
            'productSubSeriesIds',
            'baseCodeIds',
            'factoryClaimTypeIds',
            'branchIds',
        ];
        const prodSeriesToBeConvertToArray = [
            'productSeriesIds',
        ];


        const negativeValueToEmptyString = [
            'componentFactoryCode',
            'componentFunctionCodeName',
            'designTeamCode',
            'functionCodeName',
            'manufacturingModule',
            'regionCode',
        ];


        propertyToBeConvertToArray.forEach( propertyName => {

            if ( propertyName === 'productSeriesIds' ) {

                payLoad.productSeriesIds = payLoad.productSeriesIds === '-1' ? '' : payLoad.productSeriesIds;

            }

            const propertyValue = payLoad[propertyName];


            payLoad[propertyName] = convertToArray( propertyValue );

        } );
        prodSeriesToBeConvertToArray.forEach( propertyName => {

            if ( propertyName === 'productSeriesIds' ) {

                payLoad.productSeriesIds = payLoad.productSeriesIds === '-1' ? '' : payLoad.productSeriesIds;

            }

            const propertyValue = payLoad[propertyName];


            payLoad[propertyName] = convertToArrayProdSeries( propertyValue );

        } );

        negativeValueToEmptyString.forEach( propertyName => {

            const propertyValue = payLoad[propertyName];

            if ( propertyValue === '-1' ) payLoad[propertyName] = '';

        } );


        const errMsg = [];
        let anyMandatoryFieldsFilled = false;
        mandatoryValidateProperty.forEach( propertyName => {

            const propertyValue = payLoad[propertyName];

            if ( propertyValue !== '' ) {

                if ( ( propertyName === 'pins' ) && isValidEntry ) {

                    anyMandatoryFieldsFilled = true;
                    if ( !this.validatePin( payLoad[propertyName] ) ) {

                        errMsg.push( `${this.getSearchedLabels[propertyName]} should be 13 or 17 digits` );
                        isValidEntry = false;
                        return isValidEntry;

                    }

                } else if ( ( propertyName === 'pipNumbers' ) && isValidEntry ) {

                    anyMandatoryFieldsFilled = true;
                    if ( !this.validatePip( payLoad[propertyName] ) ) {

                        errMsg.push( `${this.getSearchedLabels[propertyName]} should be 8 digits` );
                        isValidEntry = false;
                        return isValidEntry;

                    }

                } else if ( propertyName === 'partNumber' && isValidEntry ) {

                    if ( !this.validatePartNumber( payLoad[propertyName] ) ) {

                        errMsg.push( `${this.getSearchedLabels[propertyName]} should be maximum 12 digits` );
                        isValidEntry = false;
                        return isValidEntry;

                    }


                    if ( propertyName === 'claimNumbers' && isValidEntry ) {

                        anyMandatoryFieldsFilled = true;
                        if ( !this.validateClaimNumber( payLoad[propertyName] ) ) {

                            errMsg.push( `${this.getSearchedLabels[propertyName]} should be 12 digits` );
                            isValidEntry = false;
                            return isValidEntry;

                        }

                    } else if ( Array.isArray( propertyValue ) ) {

                        if ( propertyValue.length > 0 ) anyMandatoryFieldsFilled = true;

                    } else if ( typeof ( propertyValue ) === 'object' && isValidEntry ) {

                        if ( ( propertyValue.from !== 0 &&
                        propertyValue.from !== null )
                        || ( propertyValue.to !== 0 && propertyValue.to !== null ) ) {

                            anyMandatoryFieldsFilled = true;
                            if ( !this.validateRange( payLoad[propertyName] ) ) {

                                errMsg.push( `${this.getSearchedLabels[propertyName]} should be in valid range` );
                                isValidEntry = false;
                                return isValidEntry;

                            }

                        }

                    }

                } else {

                    anyMandatoryFieldsFilled = true;

                }

            }

            return false;

        } );


        payLoad.factoryCode = payLoad.factoryCode === '-1' ? '' : payLoad.factoryCode;

        if ( payLoad.baseCodeIds.length > 0 ) {

            payLoad.productSubSeriesIds = [];

        }

        manipulatePayloadProperty.forEach( propertyName => {

            if ( payLoad[propertyName] !== '' ) {

                payLoad[propertyName] = filterEmpty( payLoad[propertyName] );

            } else payLoad[propertyName] = [];

        } );


        mandatoryCheck.forEach( element => {

            payLoad[element].from = payLoad[element].from > 0 ?
                new Date( payLoad[element].from ).getTime() / 1000 : 0;

            payLoad[element].to = payLoad[element].to > 0 ?
                new Date( payLoad[element].to ).getTime() / 1000 : 0;

        } );


        setTimeout( () => {

            if ( !anyMandatoryFieldsFilled ) {

                errMsg.push( 'Please fill any mandatory field' );

            }


            if ( !anyMandatoryFieldsFilled || !isValidEntry || !this.state.isValidEntry ) {

                errMsg.forEach( errMessage => {

                    customizeErrorAlert( errMessage );

                } );

            } else if ( ( download ).indexOf( 'factory-report' ) >= 0 ) {

                this.getDownloadReport( 'factory-report', payLoad, 'factory_data_extract.csv' );


            } else if ( ( download ).indexOf( 'default-report' ) >= 0 ) {

                this.getDownloadReport( 'default-report', payLoad, 'default-report.xls' );

            } else if ( ( download ).indexOf( 'analysis-comments-report' ) >= 0 ) {

                this.getDownloadReport( 'analysis-comments-report', payLoad, 'analysis-comments-report.csv' );

            } else if ( ( download ).indexOf( 'text-extract-report' ) >= 0 ) {

                this.getDownloadReport( 'text-extract-report', payLoad, 'text-extract-report.csv' );


            } else if ( ( download ).indexOf( 'replacement-part-report' ) >= 0 ) {

                this.getDownloadReport( 'replacement-part-report', payLoad, 'replacement-part-report.xls' );

            } else {
console.log("********");
                this.props.increaseCounter();
                getSearchedClaimData( payLoad ).then( response => {

                    this.setState( {
                        isSearch: true,
                        claimList: response,
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        }, 500 );


    }

    // multiEntryValidation = propertyValue => {

    //     const multiEntry = filterEmpty( propertyValue );
    //     let validEntry = true;
    //     multiEntry.forEach( num => {

    //         const numb = isAlphanumeric( num.trim() );
    //         if ( !numb ) validEntry = false;

    //         return validEntry;

    //     } );

    //     return validEntry;

    // }

    getDownloadReport = ( report, payLoad, reportname ) => {

        this.props.increaseCounter();
        getFindClaimDownloadReports( report, payLoad ).then( response => {

            getAdminReportDownload( response, reportname );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    multiEntryValidation = ( propertyName, propertyValue ) => {

        let multiEntry;
        if ( propertyName === 'pipNumbers' ) {

            const updatedpropertyValue = propertyValue.replace( /\n/g, ',' ),
                convertedArray = updatedpropertyValue.split( ',' );

            convertedArray.forEach( ( element, index ) => {

                convertedArray[index] = element;

            } );

            const cleanArr = convertedArray.filter( el => el !== null );
            multiEntry = cleanArr;

        } else {

            multiEntry = filterEmpty( propertyValue );

        }

        let validEntry = true;
        multiEntry.forEach( num => {

            const numb = propertyName === 'partNumber' ? isPartNumberValid( num ) : isAlphanumeric( num.trim(), propertyName );
            if ( !numb ) validEntry = false;

            return validEntry;

        } );

        return validEntry;

    }


    validatePartNumber = propertyValue => {

        const partNumbers = filterEmpty( propertyValue );
        let validEntry = true;
        partNumbers.forEach( num => {

            const numb = isPartNumberValid( num );
            if ( validEntry && ( !numb || num.trim() === '' || ( num.trim() ).length > 12 ) ) {

                validEntry = false;
                return false;

            }
            return validEntry;

        } );

        return validEntry;

    }

    validateSupplierId = propertyValue => {

        const partNumbers = filterEmpty( propertyValue );
        let validEntry = true;
        partNumbers.forEach( num => {

            const numb = isSupplierIdValid( num );
            if ( validEntry && ( !numb || num.trim() === '' || ( num.trim() ).length > 10 ) ) {

                validEntry = false;
                return false;

            }
            return validEntry;

        } );

        return validEntry;

    }

    validateModelCd = propertyValue => {

        const modelcds = filterEmpty( propertyValue );
        let validEntry = true;
        modelcds.forEach( num => {

            const numb = isModelCdValid( num );
            if ( validEntry && ( !numb || num.trim() === '' || ( num.trim() ).length > 5 ) ) {

                validEntry = false;
                return false;

            }
            return validEntry;

        } );

        return validEntry;

    }

    validateClaimNumber = propertyValue => {
        console.log("validateClaimNumber");

        const claimNumbers = filterEmpty( propertyValue );
        let validEntry = true;
        const allowEmpty = false;
        claimNumbers.forEach( num => {

            const numb = isAlphanumeric( num, allowEmpty );
            if ( !numb || num.trim() === '' || ( num.trim() ).length > 12 ) {

                validEntry = false;
                return false;

            }
            return true;

        } );

        this.updateStatus( validEntry );
        return validEntry;

    }

    updateStatus = validEntry => {

        this.setState( {
            ...this.state,
            isValidEntry: validEntry,
        } );

    }

    validatePin = propertyValue => {
        console.log("propertyValue ",propertyValue);

        const pipOrPip = filterEmpty( propertyValue );
        let validEntry = true;
        pipOrPip.forEach( num => {

            const numb = isAlphanumeric( num );
            if ( validEntry && ( !numb || num.trim() === '' || ( ( num.trim() ).length !== 13 && ( num.trim() ).length !== 17 ) ) ) {

                validEntry = false;
                // return false;

            }

            return validEntry;

        } );

        return validEntry;

    }

    validatePip = propertyValue => {

        const arr = stringToArray( propertyValue ),
            allowEmpty = true,
            cleanArr = arr.filter( el => el !== null && el.trim() !== '' );
        let validEntry = true;
        cleanArr.forEach( num => {

            const numb = isAlphanumeric( num, allowEmpty );
            if ( validEntry && ( !numb || num.length > 8 ) ) {

                validEntry = false;
                // return false;

            }
            return validEntry;

        } );
        return validEntry;

    }
    validateCreditMemo = propertyValue => {

        const creditMemoNumbers = filterEmpty( propertyValue );
        let validEntry = true;
        creditMemoNumbers.forEach( num => {

            const numb = isAlphanumeric( num );
            if ( validEntry && ( !numb || num.trim() === '') ) {

                validEntry = false;
                // return false;

            }

            return validEntry;

        } );

        return validEntry;

    }
    validateWorkOrderNumber = propertyValue => {

        const workOrderNumbers = filterEmpty( propertyValue );
        let validEntry = true;
        workOrderNumbers.forEach( num => {

            const numb = isAlphanumeric( num );
            if ( validEntry && ( !numb || num.trim() === '') ) {

                validEntry = true;
                // return false;

            }

            return validEntry;

        } );

        return validEntry;

    }
    validatedealerAccount = propertyValue => {

        const dealerAccount = filterEmpty( propertyValue );
        let validEntry = true;
        dealerAccount.forEach( num => {

            const numb = isAlphanumeric( num );
            if ( validEntry && ( !numb || num.trim() === '') ) {

                validEntry = false;
                // return false;

            }

            return validEntry;

        } );

        return validEntry;

    }
    validateMultiEntries = event => {

        // console.log("event.target",event.target);
        const propertyName = event.target.name;
        const propertyValue = ( event.target.value ).trim();

        this.setState( {
            isValidEntry: true,
        } );

        if ( propertyName === 'partNumber' ) return this.validatePartNumber( propertyValue );
        if ( propertyName === 'claimNumbers' ) return this.validateClaimNumber( propertyValue );
        if ( propertyName === 'pipNumbers' ) return this.validatePip( propertyValue );
        if ( propertyName === 'supplierId' ) return this.validateSupplierId( propertyValue );
        if ( propertyName === 'modelCdList' ) return this.validateModelCd( propertyValue );
        if ( propertyName === 'creditMemoNumber' ) return this.validateCreditMemo( propertyValue );
        if ( propertyName === 'workOrderNumber' ) return this.validateWorkOrderNumber( propertyValue );
        if ( propertyName === 'dealerAccount' ) return this.validatedealerAccount( propertyValue );
        return this.validatePin( propertyValue );

    }

    updateCurrentState = properties => {

        const updatedInputs = { ...this.state.searchInputs };
        Object.keys( properties ).forEach( key => {

            updatedInputs[key] = properties[key];

        } );
        this.setState( {
            searchInputs: updatedInputs,
        } );
        this.updatedSrcInputs( getUserEditedInputs( updatedInputs ) );

    }

    updateMultiEntryInput = event => {

        const { name, value } = event.target;
        const updatedProps = cloneDeep( this.state.searchInputs );
        updatedProps[name] = value;

        this.setState( {
            searchInputs: updatedProps,
        } );
        this.updatedSrcInputs( getUserEditedInputs( updatedProps ) );

    }

    updateGridAPI = gridApi => {

        this.setState( {
            gridAPI: gridApi,
        } );

    }


    updateSearchInput = event => {

        const { name, value } = event.target,
            updatedProps = cloneDeep( this.state.searchInputs );
        let validateVal = isAlphanumeric( value > 0 ? value : true );
        if ( name === 'claimNumbers' || name === 'pins' ) validateVal = isAlphanumeric( value, false );
        else if ( name === 'partNumber' ) validateVal = isPartNumberValid( value );
        else if ( name === 'pipNumbers' ) validateVal = isAlphanumeric( value, true );
        else if ( name === 'supplierId' ) validateVal = isSupplierIdValid( value );
        else if ( name === 'modelCdList' ) validateVal = isAlphanumeric( value, true );
        if ( validateVal ) {

            if (name === "creditMemoNumber" || name === "workOrderNumber" || name === "dealerAccount") {
                updatedProps[name] = value.split(",").map(entry => entry.trim());
              } else {
                updatedProps[name] = value;
              }
              updatedProps[name] = value;
            this.setState( {
                searchInputs: updatedProps,
            } );
            this.updatedSrcInputs( getUserEditedInputs( updatedProps ) );

        }


    }


    onEditSearch = () => {

        this.setState( {
            isSearch: false,
        } );

    }

    onBackToResult = () => {

        this.setState( {
            isClaimDetails: false,
        } );

    }

    onNewSearch = () => {

        this.setState( {
            searchInputs: defaultClaimSrcProperties,
            modifiedSearch: [],
            isSearch: false,
        } );

        this.loadDefaults();

    }

    validateOnfatoryCodeEmpty = updatedProps => {

        const propertyTobeUpdate = updatedProps;

        if ( updatedProps.factoryCode === '' ) {

            const factoryCodeDependency = [
                'productSeriesIds',
                'productSubSeriesIds',
                'baseCodeIds',
                'designTeamCode',
                'manufacturingModule',
                'factoryClaimTypeIds',
                'modelCdList',
            ];

            factoryCodeDependency.forEach( propertyName => {

                propertyTobeUpdate[propertyName] = '';

            } );

            this.setState( {
                searchInputs: updatedProps,
            } );
            this.updatedSrcInputs( getUserEditedInputs( updatedProps ) );

        }

    }

    handleFactoryCodeChange = id => {

        const updatedProps = cloneDeep( this.state.searchInputs );
        updatedProps.factoryCode = ( id === '-1' ) ? '' : id;
        this.setState( {
            searchInputs: updatedProps,
        } );
        this.updatedSrcInputs( getUserEditedInputs( updatedProps ) );
        this.validateOnfatoryCodeEmpty( updatedProps );

    }

    handleFactoryClaimTypeChange = () => {

        this.props.increaseCounter();

        getFactoryClaim().then( response => {

            const factoryClaimDropdown = [];
            response.forEach( factoryClaim => {

                factoryClaimDropdown.push( {
                    value: factoryClaim.claimType,
                    label: `${factoryClaim.claimType}-${factoryClaim.claimTypeDescription}`,
                } );

            } );
            this.setState( {
                FactoryClaimList: factoryClaimDropdown,
            } );

            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    updateFactoryClaim = selectedOption => {

        this.setState( { selectedFactoryClaim: selectedOption } );
        const propertiesToUpdate = {
            factoryClaimTypeIds: selectedOption === null ? '' : selectedOption,
        };
        this.updateCurrentState( propertiesToUpdate );

        // const factoryClaimList = [];
        // selectedOption.forEach( element => {

        //     factoryClaimList.push( element.value );

        // } );
        // const selectedFactoryClaim = {
        //     target: {
        //         name: 'factoryClaimTypeIds',
        //         value: factoryClaimList,
        //     },
        // };
        // this.updateSearchInput( selectedOption );


    };

    rangeFromAndTo = ( props, range, data ) => {

        const obj = { ...this.state.searchInputs[props.name] };
        if ( range === 'from' ) {

            obj[range] = ( data === null || data === '' ) ? 0 : data;

        } else if ( range === 'to' ) {

            obj[range] = ( data === null || data === '' ) ? 0 : data;

        } else {

            obj.from = data;
            obj.to = data;

        }
        return obj;

    }

    handleRangeChange = ( props, range, data ) => {

        let rangeObj = {};

        if ( props.name === 'serialNumber' ) {

            const desired = data.replace( /[^0-9]+/g, '' ).trim();
            rangeObj = this.rangeFromAndTo( props, range, desired );

        } else {

            rangeObj = this.rangeFromAndTo( props, range, data );

        }

        this.setState( {
            [props.name]: rangeObj,
        } );

        const selectedOption = {
            target: {
                name: props.name,
                value: rangeObj,
            },
        };
        this.updateSearchInput( selectedOption );

    }

    getPreviousClaimDetails = () => {

        this.onClaimDetails( this.state.claimDetailsInfo.displayedClaimIndex - 1 );

    }

    getNextClaimDetails = () => {

        this.onClaimDetails( this.state.claimDetailsInfo.displayedClaimIndex + 1 );

    }


    onClaimDetails = clickedRowIndex => {
    // console.log("clickedRowIndex",clickedRowIndex);
        this.props.increaseCounter();
        const getClickedRowDetails = this.state.gridAPI.getDisplayedRowAtIndex( clickedRowIndex ),
            totalClaims = this.state.gridAPI.getDisplayedRowCount(),
            { warrantyClaimId } = getClickedRowDetails.data,
            { claimNumber } = getClickedRowDetails.data,
            updatedProps = cloneDeep( this.state.claimDetailsInfo );

        updatedProps.totalClaims = totalClaims;
        updatedProps.displayedClaimIndex = clickedRowIndex;

        this.setState( {
            claimDetailsInfo: updatedProps,
            selectedWarrantyClaimID: warrantyClaimId,
            selectedClaimNumber: claimNumber,
            isClaimDetails: true,


        } );

        this.props.decreaseCounter();

    }

    handleCheckboxChange = checkboxChceked => {

        const obj = cloneDeep( this.state.searchInputs );
        obj.noSupplierAssigned = !this.state.searchInputs.noSupplierAssigned;
        obj.supplierId = '';

        this.setState( {
            searchInputs: obj,
        } );
        this.updatedSrcInputs( getUserEditedInputs( obj ) );
        if ( !checkboxChceked ) {

            this.setState( {
                disabled: true,
            } );

        } else {

            this.setState( {
                disabled: false,
            } );

        }

    }

    updateDesignModule = obj => {

        if ( obj ) {

            this.props.increaseCounter();
            getDesignModule( obj ).then( response => {

                this.setState( {

                    DesignModuleList: response,

                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        }

    }

    handleDesignModuleChange = obj => {

        this.setState( {
            selectedDesignModule: obj,
        } );

        const selectedOption = {
            target: {
                name: 'designTeamCode',
                value: obj === '-1' ? '' : obj,
            },
        };
        this.updateSearchInput( selectedOption );

    }

    handleAGCMDChange = obj => {

        this.setState( {
            selectedBranchCurrency: obj,
        } );

        const selectedOption = {
            target: {
                name: 'branchType',
                value: obj === '-1' ? '' : obj,
            },
        };
        this.updateSearchInput( selectedOption );

    }

    updateMfgModule = obj => {

        if ( obj ) {

            this.props.increaseCounter();
            getMfgModule( obj ).then( response => {

                this.setState( {

                    MfgModuleList: response,

                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        }

    }

    handleMfgModuleChange = obj => {

        this.setState( {
            selectedMfgModule: obj,
        } );

        const selectedOption = {
            target: {
                name: 'manufacturingModule',
                value: obj === '-1' ? '' : obj,
            },
        };
        this.updateSearchInput( selectedOption );

    }


    ComponentFactoryDropdownList = () => {

        this.props.increaseCounter();
        getComponentFactoryCode().then( response => {

            const componentFnCodeDropdwnList = [];
            response.forEach( seriesList => {

                componentFnCodeDropdwnList.push( {
                    factoryCode: seriesList.factoryCode,
                    factoryDescription: `${seriesList.factoryCode} - ${seriesList.factoryDescription}`,
                } );

            } );
            this.setState( {
                componentDropdownList: componentFnCodeDropdwnList,
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    };


    componentDropDowninfo = id => {

        this.setState( {
            componentfactoryText: id,
        } );
        const selectedOption = {
            target: {
                name: 'componentFactoryCode',
                value: id === '-1' ? '' : id,
            },
        };
        this.updateSearchInput( selectedOption );

    };

    replacePartChange = () => {

        const obj = cloneDeep( this.state.searchInputs );
        obj.includeReplacementParts = !this.state.searchInputs.includeReplacementParts;

        this.setState( {
            searchInputs: obj,
        } );

        this.updatedSrcInputs( getUserEditedInputs( obj ) );

    }

    handleOutsideClick ( event ) {

        if ( event && event.target && event.target.closest( '.downloadwrp .dropdown' ) ) return;

        document.removeEventListener( 'click', this.handleOutsideClick, false );
        this.setState( {
            showDropDownMenu: false,
        } );

    }

    render () {
        // console.log("findclaim - this.state.isSearch ",this.state.isSearch);
        // console.log("findclaim - callfrom ",this.state.callfrom);
        // console.log("this.state.isClaimDetails ",this.state.isClaimDetails);
        // console.log("this.state.includeAGCMDView ",this.state.searchInputs.option.includeAGCMDView);
        const options = this.state.factories ? this.state.factories : [];
        // const searchViewOption = this.props.searchedOptions;
        const   branchList = [
            {
                "id": "US Dollar",
                "name": "US Dollar"
            },
            {
                "id": "Branch",
                "name": "Branch"
            },
            {
                "id": "Factory",
                "name": "Factory"
            }]
        const selectedValue = this.state.searchInputs.factoryCode ? this.state.searchInputs.factoryCode : '';
        const { searchInputs } = this.state;
        const {
            manufacturingModule,
            componentFactoryCode,
            componentFunctionCodeName,
            includeReplacementParts,
            partNumber,
            supplierId,
            noSupplierAssigned
        }
        = searchInputs;
       //  console.log("this.state.searchInputs.option:",this.state.searchInputs.option);
       //  console.log("this.state.searchInputs.option***:",this.state.searchInputs.option.includeAGCMDView);
       // console.log("this.state.popupName",this.state.popupName);
        return (
            <div>
                {!this.state.isSearch && (
                    <section>
                        <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                        <header>
                            <div>
                                <h2 className="page-header">
                                    Find Claim
                                </h2>

                            </div>
                            <div className="downloadwrp">
                                <button className="primary-button" onClick={this.onSubmit} type="button"><span> Submit </span></button>
                                <div className="dropdown">
                                    <button className="report-button dropdown-toggle" onClick={this.onToggleDiv} type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <span className="downlaod">Download Report</span>
                                        <i className={`fa fa-caret-down ${this.state.showDropDownMenu ? 'up' : ''}`} />
                                    </button>
                                    <div className={`dropdown-menu ${this.state.showDropDownMenu ? ' show ' : 'hide'}`} aria-labelledby="dropdownMenuButton1">
                                        <span href="#" className="dropdown-item default-report" onClick={this.onSubmit}>Default Report</span>
                                        <span href="#" className="dropdown-item replacement-part-report" onClick={this.onSubmit}>Replacement Part Report</span>
                                        <span href="#" className="dropdown-item factory-report" onClick={this.onSubmit}>Factory Data Extract Report</span>
                                        <span href="#" className="dropdown-item text-extract-report" onClick={this.onSubmit}>Text Extract Report</span>
                                        <span href="#" className="dropdown-item analysis-comments-report" onClick={this.onSubmit}>Analysis Comments Report</span>
                                    </div>
                                </div>

                            </div>


                        </header>
                        <div className="section-with-aside">
                            <main>
                                <Accordion
                                    accordionId="basic-search-accordion"
                                    title="Basic Search"
                                    subTitle={this.accordionSecondaryText()}
                                    secondaryText={this.state.claimCount.basicSrcInps === 0 ?
                                        'None Selected' :
                                        `${this.state.claimCount.basicSrcInps} Selected`}
                                    isExpanded={true}
                                >
                                    <div className="rows three-cols">
                                        <OptionsDropDown
                                            isPlaceholderTranslated={true}
                                            optionDisplayAttributes={['factoryDescription']}
                                            optionKey="factoryCode"
                                            options={options}
                                            label="Factory Code"
                                            onChange={this.updateFactoryCode.bind( this )}
                                            placeholder=""
                                            selectedValue={selectedValue}
                                        />
                                        
                                    </div>
                                    <div className="rows three-cols">
                                        <LabeledNumberRangePicker
                                            to={this.state.searchInputs.serialNumber.to
                                                === 0 ? null :
                                                this.state.searchInputs.serialNumber.to}
                                            from={this.state.searchInputs.serialNumber.from
                                                === 0 ? null
                                                : this.state.searchInputs.serialNumber.from
                                            }
                                            onChange={this.handleRangeChange.bind( this )}
                                            className="serial-number"
                                            name="serialNumber"
                                            label="Serial Number"
                                            isRequired={true}
                                        />
                                    </div>
                                    <div className="rows three-cols">
                                        <LabeledDateRangePicker
                                            to={this.state.searchInputs.processDate.to}
                                            from={this.state.searchInputs.processDate.from}
                                            onChange={this.handleRangeChange.bind( this )}
                                            className="process-date"
                                            name="processDate"
                                            label="Process Date"
                                            isRequired={true}
                                            dateFormat="MM/dd/yyyy"
                                        />
                                    </div>
                                    {( !this.valuesHavingSeparators(
                                        this.state.searchInputs.claimNumbers,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <InputWithFaIcon
                                                    className="Claim"
                                                    name="claimNumbers"
                                                    isEditable={true}
                                                    label="Claim Number"
                                                    maxLength={12}
                                                    value={this.state.searchInputs.claimNumbers}
                                                    onChange={this.updateSearchInput}
                                                    iconClassName="fa-plus-square"
                                                    isMandatory={true}
                                                    type="text"
                                                    onIconClick={this.initiatePopup.bind( this, 'claimNumbers' )}
                                                />
                                            </div>

                                        )}

                                    {( this.valuesHavingSeparators(
                                        this.state.searchInputs.claimNumbers,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <div className="form-group claimnumbers edit-less">
                                                    <label>Claim Number</label>
                                                    <span className="asterisk-icon mandatory">
                                                        <i className="fa fa-asterisk" />
                                                    </span>
                                                    <div>
                                                        <span>
                                                            {' '}
                                                            {this.noOfEntries(
                                                                this.state
                                                                    .searchInputs.claimNumbers,
                                                            )}
                                                            {' '}
                                                            Selected
                                                            {' '}
                                                            <span className="pull-right multipleStyle">
                                                                <button
                                                                    type="button"
                                                                    className="Claim"
                                                                    onClick={this.initiatePopup.bind( this, 'claimNumbers' )}
                                                                >
                                                                    Edit Selection
                                                                    {' '}
                                                                </button>
                                                            </span>
                                                            {' '}

                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    {( !this.valuesHavingSeparators(
                                        this.state.searchInputs.pipNumbers,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <InputWithFaIcon
                                                    className="PIP"
                                                    name="pipNumbers"
                                                    isEditable={true}
                                                    label="PIP Number"
                                                    maxLength={8}
                                                    value={this.state.searchInputs.pipNumbers}
                                                    onChange={this.updateSearchInput}
                                                    iconClassName="fa-plus-square"
                                                    isMandatory={true}
                                                    type="text"
                                                    onIconClick={this.initiatePopup.bind( this, 'pipNumbers' )}
                                                />
                                            </div>
                                        )}
                                    {( this.valuesHavingSeparators(
                                        this.state.searchInputs.pipNumbers,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <div className="form-group pipnumbers edit-less">
                                                    <label>PIP Number</label>
                                                    <span className="asterisk-icon mandatory">
                                                        <i className="fa fa-asterisk" />
                                                    </span>
                                                    <div>
                                                        <span>
                                                            {' '}
                                                            {this.noOfEntries(
                                                                this.state.searchInputs.pipNumbers,
                                                            )}
                                                            {' '}
                                                            Selected
                                                            {' '}
                                                            <span className="pull-right multipleStyle">
                                                                <button
                                                                    type="button"
                                                                    className="PIP"
                                                                    onClick={this.initiatePopup.bind( this, 'pipNumbers' )}
                                                                >
                                                                    Edit Selection
                                                                    {' '}
                                                                </button>
                                                            </span>
                                                            {' '}

                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    {( !this.valuesHavingSeparators(
                                        this.state.searchInputs.pins,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <InputWithFaIcon
                                                    className="PIN"
                                                    name="pins"
                                                    isEditable={true}
                                                    label="PIN Number"
                                                    maxLength={17}
                                                    value={this.state.searchInputs.pins}
                                                    onChange={this.updateSearchInput}
                                                    iconClassName="fa-plus-square"
                                                    isMandatory={true}
                                                    onIconClick={this.initiatePopup.bind( this, 'pins' )}
                                                />
                                            </div>
                                        )}
                                    {( this.valuesHavingSeparators(
                                        this.state.searchInputs.pins,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <div className="form-group pins edit-less">
                                                    <label>PIN Number</label>
                                                    <span className="asterisk-icon mandatory">
                                                        <i className="fa fa-asterisk" />
                                                    </span>
                                                    <div>
                                                        {' '}
                                                        <span>
                                                            {' '}
                                                            {this.noOfEntries(
                                                                this.state.searchInputs.pins,
                                                            )}
                                                            {' '}
                                                            Selected
                                                            {' '}
                                                            <span className="pull-right multipleStyle">
                                                                <button
                                                                    type="button"
                                                                    className="PIN"
                                                                    onClick={this.initiatePopup.bind( this, 'pins' )}
                                                                >
                                                                    Edit Selection
                                                                </button>
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    {( !this.valuesHavingSeparators(
                                        this.state.searchInputs.partNumber,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <InputWithFaIcon
                                                    className="Part"
                                                    name="partNumber"
                                                    isEditable={true}
                                                    label="Part Number"
                                                    maxLength={12}
                                                    value={this.state.searchInputs.partNumber}
                                                    onChange={this.updateSearchInput}
                                                    iconClassName="fa-plus-square"
                                                    onIconClick={this.initiatePopup.bind( this, 'partNumber' )}
                                                />
                                                <Checkbox
                                                    className={( this.state.searchInputs.partNumber === '' ) ? 'disable-Cls' : ''}
                                                    name="includeReplacementParts"
                                                    label="Include Replacement Parts"
                                                    id="includeReplacementParts"
                                                    value={includeReplacementParts}
                                                    handleCheckboxChange={this.replacePartChange}
                                                    isChecked={includeReplacementParts}
                                                />
                                            </div>
                                        )}
                                    {( this.valuesHavingSeparators(
                                        this.state.searchInputs.partNumber,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <div className="form-group pipnumbers edit-less">
                                                    <label>Part Number</label>
                                                    <div>
                                                        <span>
                                                            {' '}
                                                            {this.noOfEntries( partNumber )}
                                                            {' '}
                                                            Selected
                                                            {' '}
                                                            <span className="pull-right multipleStyle">
                                                                <button
                                                                    type="button"
                                                                    className="Part"
                                                                    onClick={this.initiatePopup.bind( this, 'partNumber' )}
                                                                >
                                                                  Edit Selection
                                                                </button>
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <Checkbox
                                                    className={( this.state.searchInputs.partNumber === '' ) ? 'disable-Cls' : 'enable-Cls'}
                                                    name="includeReplacementParts"
                                                    label="Include Replacement Parts"
                                                    id="edit-includeReplacementParts"
                                                    value={includeReplacementParts}
                                                    handleCheckboxChange={this.replacePartChange}
                                                    key={includeReplacementParts}
                                                    isChecked={includeReplacementParts}
                                                />
                                            </div>
                                        )}

                                    <div className="rows three-cols">
                                        <LabeledDateRangePicker
                                            to={this.state.searchInputs.buildDate.to}
                                            from={this.state.searchInputs.buildDate.from}
                                            onChange={this.handleRangeChange.bind( this )}
                                            className="build-date"
                                            name="buildDate"
                                            label="Build Date"
                                            isRequired={true}
                                            dateFormat="MM/dd/yyyy"
                                        />
                                    </div>
                                    <div className="rows three-cols">
                                        <LabeledMonthRangePicker
                                            to={this.state.searchInputs.buildMonth.to}
                                            from={this.state.searchInputs.buildMonth.from}
                                            onChange={this.handleRangeChange.bind( this )}
                                            className="build-month"
                                            name="buildMonth"
                                            label="Build Month"
                                            dateFormat="yyyyMM"
                                            isRequired={true}
                                        />
                                    </div>
                                    <div className="rows three-cols">
                                        <LabeledTextarea
                                            className="basic-claim-info partDescription"
                                            name="partDescription"
                                            isEditable={true}
                                            label="Part Description"
                                            value={this.state.searchInputs.partDescription}
                                            onChange={this.updateSearchInput}
                                        />
                                    </div>
                                    <div className="rows three-cols">
                                        <label>Factory Claim Type</label>
                                        <MultiSelect
                                            isPlaceholderTranslated={true}
                                            optionDisplayAttributes={['claimTypeDescription']}
                                            optionKey="claimType"
                                            options={this.state.FactoryClaimList}
                                            onChange={this.updateFactoryClaim.bind( this )}
                                            value={this.state.searchInputs.factoryClaimTypeIds}
                                            isMulti="true"
                                            menuPlacement="auto"
                                            maxMenuHeight={240}
                                            className="claimType-cls"
                                        />
                                    </div>
                                    {( !this.valuesHavingSeparators(
                                        this.state.searchInputs.modelCdList,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <InputWithFaIcon
                                                    className="Model"
                                                    name="modelCdList"
                                                    isEditable={true}
                                                    isDisabled={this.state.searchInputs.factoryCode === ''}
                                                    label="Model Number"
                                                    maxLength={5}
                                                    value={this.state.searchInputs.modelCdList}
                                                    onChange={this.updateSearchInput}
                                                    iconClassName="fa-plus-square"
                                                    onIconClick={this.initiatePopup.bind( this, 'modelCdList' )}
                                                />
                                                <span className={`model-alert ${this.state.searchInputs.factoryCode === '' ? 'show' : 'hide'}`}>Please select Factory Code to Enable this Criteria</span>
                                            </div>
                                        )}
                                    {( this.valuesHavingSeparators(
                                        this.state.searchInputs.modelCdList,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <div className="form-group pins edit-less">
                                                    <label>Model Number</label>
                                                    <div>
                                                        {' '}
                                                        <span>
                                                            {' '}
                                                            {this.noOfEntries(
                                                                this.state.searchInputs.modelCdList,
                                                            )}
                                                            {' '}
                                                            Selected
                                                            {' '}
                                                            <span className="pull-right multipleStyle">
                                                                <button
                                                                    type="button"
                                                                    className="Model"
                                                                    onClick={this.initiatePopup.bind( this, 'modelCdList' )}
                                                                >
                                                                    Edit Selection
                                                                </button>
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    {this.state.isPopupOpen && (

                                        <SimpleMultipleEntryPopup
                                            panelName={this.state.popupName}
                                            isOpen={this.state.isPopupOpen}
                                            onClose={this.onClosePopup}
                                            onUpdateProperty={this.updateMultiEntryInput.bind(
                                                this.props,
                                            )}
                                            propertyName={this.state.popupPropertyName}
                                            propertyValue={this.state.popupPropertyValue}
                                            onApplyValidate={this.validateMultiEntries.bind(
                                                this.props,
                                            )}
                                            validateEntry={this.validatePin.bind( this )}
                                            isValidEntry={this.state.isValidEntry}
                                            multiEntryValidation={this.multiEntryValidation
                                                .bind( this, this.state.popupPropertyName )}
                                        />
                                    )}
                                    {this.state.searchInputs.option.includeAGCMDView ? 
                                     <div className="rows three-cols">
                                        {/* <LabeledInput
                                            name="creditMemoNumber"
                                            isEditable={true}
                                            label="Credit Memo Number"
                                          //  maxLength={10}
                                            value={this.state.searchInputs
                                                .creditMemoNumber}
                                            onChange={this.updateSearchInput}
                                        /> */}

                                    {( !this.valuesHavingSeparators(
                                        this.state.searchInputs.creditMemoNumber,
                                    ) )
                                        && (
                                                <InputWithFaIcon
                                                    className="CRED"
                                                    name="creditMemoNumber"
                                                    isEditable={true}
                                                    label="Credit Memo Number"
                                                    value={this.state.searchInputs.creditMemoNumber}
                                                    onChange={this.updateSearchInput}
                                                    iconClassName="fa-plus-square"
                                                    isMandatory={true}
                                                    type="text"
                                                    onIconClick={this.initiatePopup.bind( this, 'creditMemoNumber' )}
                                                />
                                        )}
                                    {( this.valuesHavingSeparators(
                                        this.state.searchInputs.creditMemoNumber,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <div className="form-group creditMemoNumber edit-less">
                                                    <label>Credit Memo Number</label>
                                                    <span className="asterisk-icon mandatory">
                                                        <i className="fa fa-asterisk" />
                                                    </span>
                                                    <div>
                                                        <span>
                                                            {' '}
                                                            {this.noOfEntries(
                                                                this.state.searchInputs.creditMemoNumber,
                                                            )}
                                                            {' '}
                                                            Selected
                                                            {' '}
                                                            <span className="pull-right multipleStyle">
                                                                <button
                                                                    type="button"
                                                                    className="CRED"
                                                                    onClick={this.initiatePopup.bind( this, 'creditMemoNumber' )}
                                                                >
                                                                    Edit Selection
                                                                    {' '}
                                                                </button>
                                                            </span>
                                                            {' '}

                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div> : null }
                                    {this.state.searchInputs.option.includeAGCMDView ? 
                                    <div className="rows three-cols">
                                        {/* <LabeledInput
                                            name="workOrderNumber"
                                            isEditable={true}
                                            label="Work Order Number"
                                           // maxLength={10}
                                            value={this.state.searchInputs
                                                .workOrderNumber}
                                            onChange={this.updateSearchInput}
                                        /> */}

{( !this.valuesHavingSeparators(
                                        this.state.searchInputs.workOrderNumber,
                                    ) )
                                        && (
                                                <InputWithFaIcon
                                                    className="workOrderNumber"
                                                    name="workOrderNumber"
                                                    isEditable={true}
                                                    label="Work Order Number"
                                                    value={this.state.searchInputs.workOrderNumber}
                                                    onChange={this.updateSearchInput}
                                                    iconClassName="fa-plus-square"
                                                    isMandatory={true}
                                                  //  type="text"
                                                    onIconClick={this.initiatePopup.bind( this, 'workOrderNumber' )}
                                                />
                                        )}
                                    {( this.valuesHavingSeparators(
                                        this.state.searchInputs.workOrderNumber,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <div className="form-group workOrderNumber edit-less">
                                                    <label>Work Order Number</label>
                                                    <span className="asterisk-icon mandatory">
                                                        <i className="fa fa-asterisk" />
                                                    </span>
                                                    <div>
                                                        <span>
                                                            {' '}
                                                            {this.noOfEntries(
                                                                this.state.searchInputs.workOrderNumber,
                                                            )}
                                                            {' '}
                                                            Selected
                                                            {' '}
                                                            <span className="pull-right multipleStyle">
                                                                <button
                                                                    type="button"
                                                                    className="workOrderNumber"
                                                                    onClick={this.initiatePopup.bind( this, 'workOrderNumber' )}
                                                                >
                                                                    Edit Selection
                                                                    {' '}
                                                                </button>
                                                            </span>
                                                            {' '}

                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div> :null}
                                    {this.state.searchInputs.option.includeAGCMDView ? 
                                    <div className="rows three-cols">
                                        <OptionsDropDown
                                            isPlaceholderTranslated={true}
                                            label="Currency"
                                            optionDisplayAttributes={['name']}
                                            optionKey="id"
                                            options={branchList}
                                            onChange={this.handleAGCMDChange}
                                         // onChange={(newValue) => this.setState({ branchType: newValue })}
                                            placeholder=""
                                           // selectedValue={branchList[0].name}
                                           selectedValue =  {this.state.searchInputs.branchType}
                                           // disabled={this.state.searchInputs.factoryCode === ''}
                                        />
                                    </div> :null
}
                                </Accordion>
                                
                                <Accordion
                                    accordionId="product-search-accordion"
                                    title="Product Search"
                                    secondaryText={this.state.claimCount.ProdSrcInps === 0 ?
                                        'None Selected' :
                                        `${this.state.claimCount.ProdSrcInps} Selected`}
                                >
                                    <ProductSearch
                                        defaultProperties={this.state.searchInputs}
                                        onUpdateProperty={
                                            this.updateCurrentState.bind( this.props )
                                        }
                                    />
                                </Accordion>
                                <Accordion
                                    accordionId="function-code-accordion"
                                    title="Function Code Search"
                                    secondaryText={this.state.claimCount.FuncSrcInps === 0 ?
                                        'None Selected' :
                                        `${this.state.claimCount.FuncSrcInps} Selected`}
                                >
                                    <div className={`function-search-alert ${this.state.searchInputs.factoryCode === '' ? 'show' : 'hide'}`}>
                                        Select Factory Code to enable the below disabled Options
                                    </div>
                                    <div className="rows three-cols">
                                        <LabeledInput
                                            name="functionCodeName"
                                            isEditable={true}
                                            label="Function Code"
                                            maxLength={15}
                                            value={this.state.searchInputs
                                                .functionCodeName}
                                            onChange={this.updateSearchInput}
                                        />
                                    </div>
                                    <div className="rows three-cols">
                                        <OptionsDropDown
                                            isPlaceholderTranslated={true}
                                            label="Design Module"
                                            optionDisplayAttributes={['name']}
                                            optionKey="name"
                                            options={this.state.DesignModuleList}
                                            onChange={this.handleDesignModuleChange}
                                            placeholder=""
                                            selectedValue={this.state.searchInputs.designTeamCode}
                                            disabled={this.state.searchInputs.factoryCode === ''}
                                        />
                                    </div>
                                    <div className="rows three-cols">
                                        <OptionsDropDown
                                            isPlaceholderTranslated={true}
                                            label="Mfg Module"
                                            optionDisplayAttributes={['name']}
                                            optionKey="name"
                                            options={this.state.MfgModuleList}
                                            onChange={this.handleMfgModuleChange}
                                            placeholder=""
                                            selectedValue={manufacturingModule}
                                            disabled={this.state.searchInputs.factoryCode === ''}
                                        />
                                    </div>
                                    <div className="rows three-cols">
                                        <OptionsDropDown
                                            className="dropDown-big"
                                            label="Component Factory"
                                            isPlaceholderTranslated={true}
                                            onChange={this.componentDropDowninfo.bind( this )}
                                            optionDisplayAttributes={['factoryDescription']}
                                            optionKey="factoryCode"
                                            options={this.state.componentDropdownList}
                                            placeholder=""
                                            selectedValue={componentFactoryCode}
                                        />
                                    </div>
                                    <div className="rows three-cols">
                                        <LabeledInput
                                            className="textBox-big"
                                            name="componentFunctionCodeName"
                                            isEditable={true}
                                            label="Component Function Code"
                                            maxLength={15}
                                            value={componentFunctionCodeName}
                                            onChange={this.updateSearchInput}
                                        />
                                    </div>

                                </Accordion>
                                <Accordion
                                    accordionId="region-search-accordion"
                                    title="Region Search"
                                    secondaryText={this.state.claimCount.RegionCodeSrcInps === 0 ?
                                        'None Selected' :
                                        `${this.state.claimCount.RegionCodeSrcInps} Selected`}
                                >
                                    <RegionSearch
                                        selectedRegionAndBranch={this.state.searchInputs}
                                        onUpdateProperty={
                                            this.updateCurrentState.bind( this.props )
                                        }
                                    />
                                </Accordion>
                                <Accordion
                                    accordionId="others-accordion"
                                    title="Others"
                                    secondaryText={this.state.claimCount.OtherSrcInps === 0 ?
                                        'None Selected' :
                                        `${this.state.claimCount.OtherSrcInps} Selected`}
                                >
                                    <div className="rows three-cols">
                                        {( !this.valuesHavingSeparators(
                                            this.state.searchInputs.supplierId,
                                        ) )
                                        && (
                                            <div>
                                                <InputWithFaIcon
                                                    className="Supplier"
                                                    name="supplierId"
                                                    isEditable={true}
                                                    label="Supplier Id"
                                                    maxLength={10}
                                                    value={this.state.searchInputs.supplierId}
                                                    onChange={this.updateSearchInput}
                                                    iconClassName="fa-plus-square"
                                                    isDisabled={this.state.disabled}
                                                    onIconClick={this.initiateSupplierPopup.bind( this, 'supplierId' )}
                                                />
                                                <Checkbox
                                                    className={( this.state.searchInputs.supplierId )}
                                                    name="NoSupplieronClaim"
                                                    label="No Supplier on Claim"
                                                    id="noSupplierAssigned"
                                                    value={this.state.searchInputs.noSupplierAssigned}
                                                    handleCheckboxChange={this.handleCheckboxChange.bind( this )}
                                                    isChecked={noSupplierAssigned}
                                                />
                                            </div>
                                        )}
                                        {( this.valuesHavingSeparators(
                                            this.state.searchInputs.supplierId,
                                        ) )
                                        && (
                                            <div>
                                                <div className="form-group supplierId edit-less">
                                                    <label>Supplier Id</label>
                                                    <div>
                                                        <span>
                                                            {' '}
                                                            {this.noOfEntries( supplierId )}
                                                            {' '}
                                                            Selected
                                                            {' '}
                                                            <span className="pull-right multipleStyle" isDisabled={this.state.disabled}>
                                                                <button
                                                                    type="button"
                                                                    className="SupplierId"
                                                                    onClick={this.initiateSupplierPopup.bind( this, 'supplierId' )}
                                                                >
                                                                  Edit Selection
                                                                </button>
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <Checkbox
                                                    className={( this.state.searchInputs.supplierId )}
                                                    name="noSupplierAssigned"
                                                    label="No Supplier on Claim"
                                                    id="edit-noSupplierAssigned"
                                                    value={noSupplierAssigned}
                                                    handleCheckboxChange={this.handleCheckboxChange.bind( this )}
                                                    key={noSupplierAssigned}
                                                    isChecked={noSupplierAssigned}
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className="rows three-cols">
                                        <LabeledInput
                                            name="componentPin"
                                            className=""
                                            isEditable={true}
                                            label="Component 1 PIN"
                                            maxLength={15}
                                            value={this.state.searchInputs.componentPin}
                                            onChange={this.updateSearchInput}
                                        />
                                    </div>
                                     {!this.state.searchInputs.option.includeAGCMDView ? 
                                    <div className="rows three-cols">
                                        <LabeledInput
                                            name="dealerAccount"
                                            className=""
                                            isEditable={true}
                                            label="Dealer Number"
                                            maxLength={6}
                                            value={this.state.searchInputs.dealerAccount}
                                            onChange={this.updateSearchInput}
                                        />
                                    </div> : <div className="rows three-cols">
                                    {( !this.valuesHavingSeparators(
                                        this.state.searchInputs.dealerAccount,
                                    ) )
                                        && (
                                                <InputWithFaIcon
                                                    className=""
                                                    name="dealerAccount"
                                                    isEditable={true}
                                                    label="Dealer Number"
                                                    maxLength={6}
                                                    value={this.state.searchInputs.dealerAccount}
                                                    onChange={this.updateSearchInput}
                                                    iconClassName="fa-plus-square"
                                                    isMandatory={true}
                                                    type="text"
                                                    onIconClick={this.initiatePopup.bind( this, 'dealerAccount' )}
                                                />
                                        )}
                                    {( this.valuesHavingSeparators(
                                        this.state.searchInputs.dealerAccount,
                                    ) )
                                        && (
                                            <div className="rows three-cols">
                                                <div className="form-group dealerAccount edit-less">
                                                    <label>Dealer Number</label>
                                                    <span className="asterisk-icon mandatory">
                                                        <i className="fa fa-asterisk" />
                                                    </span>
                                                    <div>
                                                        <span>
                                                            {' '}
                                                            {this.noOfEntries(
                                                                this.state.searchInputs.dealerAccount,
                                                            )}
                                                            {' '}
                                                            Selected
                                                            {' '}
                                                            <span className="pull-right multipleStyle">
                                                                <button
                                                                    type="button"
                                                                    className="DealerNumber"
                                                                    onClick={this.initiatePopup.bind( this, 'dealerAccount' )}
                                                                >
                                                                    Edit Selection
                                                                    {' '}
                                                                </button>
                                                            </span>
                                                            {' '}

                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div> }
                                </Accordion>
                            </main>

                            <aside>
                                <ClaimSearchAside
                                    viewOptions={this.state.searchInputs.option}
                                    onUpdateProperty={this.updateSearchInput.bind( this.props )}

                                />
                            </aside>
                        </div>
                    </section>
                )}
                {this.state.isSearch && (
                     <div className={( this.state.isClaimDetails ? ' hide' : ' show' )}>
                    {this.state.searchInputs.option.includeAGCMDView ?
                    <AgcmdlDetails
                     searchedOptions={this.state.searchInputs.option}
                     claimList={this.state.claimList}
                     onEditSearch={this.onEditSearch}
                     onNewSearch={this.onNewSearch}
                     searchedLabels={this.getSearchedLabels}
                     onClaimDetails={this.onClaimDetails.bind(this)}
                     editedInputs={this.state.modifiedSearch}
                     updateGridAPI={this.updateGridAPI.bind(this)}
                     callFrom="findClaim"
                     onToggleDiv={this.onToggleDiv}
                     showDropDownMenu={this.state.showDropDownMenu}
                     onSubmit={this.onSubmit}
                    />
                        
                    :
                        <SearchResultPanel
                            searchedOptions={this.state.searchInputs.option}
                            claimList={this.state.claimList}
                            onEditSearch={this.onEditSearch}
                            onNewSearch={this.onNewSearch}
                            searchedLabels={this.getSearchedLabels}
                            onClaimDetails={this.onClaimDetails.bind( this )}
                            editedInputs={this.state.modifiedSearch}
                            updateGridAPI={this.updateGridAPI.bind( this )}
                            callFrom="findClaim"
                            onToggleDiv={this.onToggleDiv}
                            showDropDownMenu={this.state.showDropDownMenu}
                            onSubmit={this.onSubmit}

                        />
                        

    }
                    </div>
                )}

                {this.state.isSearch && this.state.isClaimDetails && (
                    <div>

                            <ClaimDetailsPanel
                            warrantyClaimId={this.state.selectedWarrantyClaimID}
                            selectedClaimNumber={this.state.selectedClaimNumber}
                            claimDetailsInfo={this.state.claimDetailsInfo}
                            onBackToResult={this.onBackToResult}
                            getPreviousClaimDetails={this.getPreviousClaimDetails}
                            getNextClaimDetails={this.getNextClaimDetails}
                            callFrom="findClaim"
                        />

    {/* {!this.state.searchInputs.option.includeAGCMDView ?
                        <ClaimDetailsPanel
                            warrantyClaimId={this.state.selectedWarrantyClaimID}
                            selectedClaimNumber={this.state.selectedClaimNumber}
                            claimDetailsInfo={this.state.claimDetailsInfo}
                            onBackToResult={this.onBackToResult}
                            getPreviousClaimDetails={this.getPreviousClaimDetails}
                            getNextClaimDetails={this.getNextClaimDetails}
                            callFrom="findClaim"
                        /> :

                        <ClaimDetailsPanel
                        warrantyClaimId={this.state.selectedWarrantyClaimID}
                        selectedClaimNumber={this.state.selectedClaimNumber}
                        claimDetailsInfo={this.state.claimDetailsInfo}
                        onBackToResult={this.onBackToResult}
                        getPreviousClaimDetails={this.getPreviousClaimDetails}
                        getNextClaimDetails={this.getNextClaimDetails}
                        callFrom="findClaim"
                    />
    } */}
                    </div>
                )}
            </div>
        );

    }

}
FindClaim.displayName = 'FindClaim';
FindClaim.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    factoryCode: PropTypes.string.isRequired,
    reload: PropTypes.string.isRequired,
    updateReload: PropTypes.func.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    factoryCode: state.application.factories.factoryCode,
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) ),
} );
export default connect( mapStateToProps, mapDispatchToProps )( FindClaim );
